import { Chip } from "@heroui/react";
import { CalendarDot, Eye, User } from "@phosphor-icons/react";
import ButtonNew from "components/buttonNew/buttonNew";
import React from "react";
import { Link } from "react-router-dom";
import { ImagesContainer } from "shared/components/imagesContainer/imagesContainer";
import { BuildingDTO } from "shared/types/building";

interface CardBuildingShellProps {
  building: BuildingDTO,
  data: any;
  onOpenModal: () => void;
}

type StatusStyle = {
  baseClass: string;
  label: string;
};

type StatusStyles = {
  [key: string]: StatusStyle;
};

const statusStyles: StatusStyles = {
  "Na te kijken": {
    baseClass: "border-status-medium text-status-medium",
    label: "Na te kijken",
  },
  "Slechte staat": {
    baseClass: "border-status-bad text-status-bad",
    label: "Slechte staat",
  },
  "Goede staat": {
    baseClass: "border-status-good text-status-good",
    label: "Goede staat",
  },
};

export const renderStatusChip = (status: string) => {
  const style = statusStyles[status];

  return (
    <Chip
      className="gap-1"
      classNames={{
        base: `h-fit bg-white px-2 border ${style.baseClass}`,
        content: "px-0 font-medium",
      }}
    >
      {style.label}
    </Chip>
  );
};

export const CardBuildingShell: React.FC<CardBuildingShellProps> = ({
  building,
  data,
  onOpenModal,
}) => {
  const renderAdditionalInfo = () => {
    return data.additionalInfo.map((info: any, index: any) => (
      <li key={index} className="p-2">
        {`${info.label}: `}
        <strong>{info.value ? info.value : "Niet ingevuld"}</strong>
      </li>
    ));
  };
  return (
    <div
      onClick={onOpenModal}
      className="flex w-full cursor-pointer flex-col gap-3 rounded-lg bg-white p-4 shadow-md transition duration-250 will-change-transform hover:scale-[1.0124]"
    >
      <header className="flex items-center justify-between">
        {data.title && <p className="text-base font-medium">{data.title}</p>}
        {data.status && renderStatusChip(data.status)}
      </header>
      <div className="flex gap-3">
        <ImagesContainer
          canSelectCoverImage={false}
          canUpload={false}
          display="inline"
          buildingId={building.id as string}
          fileLabel={data.fileLabel}
          title={`Foto's van ${data.fileLabel} `}
          page={1}
          pageSize={5}
        />
        <div className="flex w-full flex-col gap-3">
          <ul className="flex w-full flex-col divide-y divide-neutral-primary/10 rounded-md border border-neutral-primary/10 text-sm">
            {renderAdditionalInfo()}
            {data && data.installer && (
              <li className="p-2">
                <Link
                  to={`/${data.installer.type}/${data.installer.resourceId}`}
                >
                  <Chip
                    className="gap-1"
                    startContent={<User weight="bold" size={14} />}
                    classNames={{
                      base: "h-fit bg-white px-2 border border-moss-primary text-moss-primary",
                      content: "px-0 font-medium",
                    }}
                  >
                    {data.installer.name}
                  </Chip>
                </Link>
              </li>
            )}
            <li className="flex items-center gap-1 p-2">
              <CalendarDot weight="bold" size={18} /> Volgende inspectiedatum:
              {data.nextInspectionDate}
            </li>
          </ul>
          <ButtonNew
            onClick={onOpenModal}
            icon={<Eye weight="bold" size={16} />}
            label="Meer details"
            variant="secondaryNeutral"
          />
        </div>
      </div>
    </div>
  );
};
